export const salaryReportReasons = [
  {
    label: '我認為公司名稱或職稱有誤',
    value: '我認為公司名稱或職稱有誤',
  },
  {
    label: '我認為薪資數額並不合理、正確',
    value: '我認為薪資數額並不合理、正確',
  },
  {
    label: '我認為工時、加班狀況並不正確',
    value: '我認為工時、加班狀況並不正確',
  },
  {
    label: '其他',
    value: '其他',
  },
];

export const experienceReportReasons = [
  {
    label: '這是廣告或垃圾訊息，或沒有參考價值',
    value: '這是廣告或垃圾訊息，或沒有參考價值',
  },
  {
    label: '這篇文章涉及人身攻擊、誹謗',
    value: '這篇文章涉及人身攻擊、誹謗',
  },
  {
    label: '這篇文章內容不實',
    value: '這篇文章內容不實',
  },
  {
    label: '這篇文章是使用 AI / ChatGPT 產生出來的，沒有參考價值',
    value: '這篇文章是使用 AI / ChatGPT 產生出來的，沒有參考價值',
  },
  {
    label: '其他',
    value: '其他',
  },
];

export const MODAL_TYPE = {
  REPORT_LIST: 'REPORT_LIST',
  REPORT_FORM: 'REPORT_FORM',
  REPORT_API_ERROR: 'REPORT_API_ERROR',
  REPORT_SUCCESS: 'REPORT_SUCCESS',
};

export const REPORT_TYPE = {
  EXPERIENCE: 'experience',
  SALARY: 'salary',
};
